import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SICOM_PATHS } from 'src/sicom-paths';

import { PrestadorGeridaEditarRequest, PrestadorGeridaPesquisaResponse, PrestadorGeridaRemoverRequest, PrestadorGeridaVincularRequest, PrestadorGeridasResponse, PrestadorGestoraResponse } from './prestador-geridas.model';

@Injectable({ providedIn: 'root' })
export class PrestadorGeridasService {
    private readonly http = inject(HttpClient);
    private readonly url = SICOM_PATHS.registro.prestador.geridas;

    /** Lista os vínculos (ativos e inativos) da gestora informada. */
    listar(id: number, uf: string): Observable<PrestadorGeridasResponse> {
        return this.http.get<PrestadorGeridasResponse>(this.url, { params: { id, uf } });
    }

    /** Localiza empresas candidatas a gerida na UF informada, com crivos (definitiva / alteraTipoGestao). */
    pesquisar(uf: string, crm?: string | null, nome?: string | null): Observable<PrestadorGeridaPesquisaResponse[]> {
        let params = new HttpParams().set('uf', uf);
        if (crm) {
            params = params.set('crm', crm);
        }
        if (nome) {
            params = params.set('nome', nome);
        }
        return this.http.get<PrestadorGeridaPesquisaResponse[]>(`${this.url}/pesquisar`, { params });
    }

    /** Retorna a gestora que administra o gerido informado (204 → sem gestora → null). */
    gestora(idGerido: number, ufGerido: string): Observable<PrestadorGestoraResponse | null> {
        return this.http.get<PrestadorGestoraResponse | null>(`${this.url}/gestora`, { params: { id: idGerido, uf: ufGerido } });
    }

    /** Baixa o documento comprobatório (PDF) do vínculo. */
    baixarDocumento(id: number, uf: string, idGerido: number, ufGerido: string, dtInicio: string): Observable<Blob> {
        const params = new HttpParams().set('id', String(id)).set('uf', uf).set('idGerido', String(idGerido)).set('ufGerido', ufGerido).set('dtInicio', dtInicio);
        return this.http.get(`${this.url}/documento`, { params, responseType: 'blob' });
    }

    vincular(request: PrestadorGeridaVincularRequest): Observable<void> {
        return this.http.post<void>(this.url, request);
    }

    editar(request: PrestadorGeridaEditarRequest): Observable<void> {
        return this.http.put<void>(this.url, request);
    }

    remover(request: PrestadorGeridaRemoverRequest): Observable<void> {
        return this.http.delete<void>(this.url, { body: request });
    }
}
